import { Container } from "../layout/Container.jsx";

// Static process steps. Mirrors the model defaults so the homepage shows
// the same content regardless of whether settings have ever been seeded.
const STEPS = [
  { title: "Research", description: "Discover designs that match your block and budget." },
  { title: "Strategic Planning", description: "Lock in inclusions, finance, and timeline." },
  { title: "Building", description: "Site cuts to handover, with a single project lead." },
  { title: "Aftercare", description: "Maintenance window + 6-, 12-month checks." },
];

export function ProcessSteps() {
  const steps = STEPS;

  return (
    <section className="border-t border-border-subtle py-20 lg:py-28">
      <Container>
        <div className="mb-12 max-w-2xl">
          <p className="eyebrow">Our process</p>
          <h2 className="mt-3 font-display text-4xl text-text-primary lg:text-5xl">
            From first sketch to handover
          </h2>
          <p className="mt-4 text-text-secondary">
            A single project lead from day one to handover, fixed-price guarantee, and a 6/12-month
            aftercare review built into every contract.
          </p>
        </div>

        <ol className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-4">
          {steps.map((step, i) => (
            <li
              key={step.title ?? i}
              className="relative rounded-2xl border border-border-subtle bg-bg-elevated p-6 transition-colors hover:border-accent/60"
            >
              <span className="font-display text-3xl text-accent">0{i + 1}</span>
              <h3 className="mt-3 font-display text-xl text-text-primary">{step.title}</h3>
              {step.description && (
                <p className="mt-2 text-sm text-text-secondary">{step.description}</p>
              )}
              {i < steps.length - 1 && (
                <span
                  aria-hidden
                  className="absolute right-[-14px] top-12 hidden h-px w-7 bg-border lg:block"
                />
              )}
            </li>
          ))}
        </ol>
      </Container>
    </section>
  );
}
